import createStore from "zustand";
import { persist } from "zustand/middleware";
import API from "../utility/Api";

export default createStore(
  persist(
    (set, get) => ({
      admin: null,
      token: null,
      tunnel: [],
      setAdmin: (admin, token) => {
        set((state) => {
          state.admin = admin;
          state.token = token;
        });
      },
      fetchAdminConfig: async () => {
        const api = new API(get().token);
        const response = await api.fetchAdminConfig({});
        if (response && response.ok) {
          set((state) => {
            state.tunnel = response.data.tunnel;
          });
        }
      },
    }),
    {
      name: "tms-admin-cms", // unique name
      getStorage: () => localStorage, // Add this here!
    }
  )
);
